import { OPERATION_STATE } from "./actions";
import ServiceApi from "../services/ServiceApi";

export const ACTIONS_TYPE = {
  SET_JOB_PROGRESS_HISTORY: "SET_JOB_PROGRESS_HISTORY",
  SET_JOB_EXCLUSION_LIST: "SET_JOB_EXCLUSION_LIST",
};

export function setJobProgressHistory(payloads) {
  return (dispatch, getState) => {
    dispatch({
      type: ACTIONS_TYPE.SET_JOB_PROGRESS_HISTORY,
      payloads: payloads,
    });
  };
}

export function setJobExclusions(payloads) {
  return (dispatch, getState) => {
    dispatch({
      type: ACTIONS_TYPE.SET_JOB_EXCLUSION_LIST,
      payloads: payloads,
    });
  };
}

// todo w8 to set job full detail set in dispatch
export function approveExclusion(value) {
  return async (dispatch, getState) => {
    try {
      const { data: res } = await ServiceApi.post(
        `job_detail/ApprovejobExclusion`,
        value
      );
      // console.log("res", res);
      return res;
    } catch (error) {
      throw error;
    }
    // dispatch({
    //   type: ACTIONS_TYPE.SET_JOB_PROGRESS_HISTORY,
    //   payloads: payloads,
    // });
  };
}

// todo w8 to set job full detail set in dispatch
export function rejectExclusion(value) {
  return async (dispatch, getState) => {
    try {
      const { data: res } = await ServiceApi.post(
        `job_detail/RejectjobExclusion`,
        value
      );
      // console.log("res", res);
      return res;
    } catch (error) {
      throw error;
    }
    // dispatch({
    //   type: ACTIONS_TYPE.SET_JOB_PROGRESS_HISTORY,
    //   payloads: payloads,
    // });
  };
}
